const entries = (obj) => {
	let ownProps = Object.keys(obj),
		i = ownProps.length,
		resArray = new Array(i);
	while (i--)
		resArray[i] = [ownProps[i], obj[ownProps[i]]];
	return resArray;
};

/**
 * intentObjToUrl is a method that takes in an intent object and converts to a url
 * this is an evolution of an intent string that is less terrible
 * @param {String} intentObj
 * @param {String} origin, optional. Will prefix with origin.
 * @return {String} url, returns false if it cannot be processed.
 */
export default function intentObjToUrl (intentObj, origin) {
	let map, path;
	if (!intentObj || typeof intentObj !== 'object') {
		return false;
	}

	origin = origin || '';

	if (intentObj.href) {
		return intentObj.href;
	}

	if (typeof INTENT_PARAMS_MAP[intentObj.type] === 'undefined') {
		return false;
	}

	map = INTENT_PARAMS_MAP[intentObj.type];

	path = map._path;

	// iterate over intentObj
	entries(intentObj.meta).map(k => {
		let key = k[0];
		if (map[key]) {
			key = map[key];
		}
		path += '/'+key+'/'+k[1];
	});
	return origin+path;
}

const INTENT_PARAMS_MAP = {
	video: {
		_path: '/player',
		canonical: 'article',
		asset: 'article'
	},
	article: {
		_path: '/news/read'
	},
	slideshow: {
		_path: '/slideshow',
		asset: 'article'
	},
	game: {
		_path: '/games/play',
		article: 'canonical'
	}
};



// WEBPACK FOOTER //
// ../node_modules/@cube/intent-to-url/src/intentObjToUrl.js